import { Component, ContentChildren, QueryList, AfterContentInit } from '@angular/core';
import { TabHeader } from "./tab-header.component";

@Component({
	selector: 'tabbar',
	templateUrl: "./tabbar.html",
	styles: [require("./tabbar.scss")]

})
export class Tabbar {
	@ContentChildren(TabHeader) tabHeader: QueryList<TabHeader>;

}



// WEBPACK FOOTER //
// ./src/app/ui-helper/routing-tabs/tabbar.component.ts